import { configs as blockConfigs } from './blocks'
import { configs as itemConfigs } from './items'

export default {
  blocks: blockConfigs,
  items: itemConfigs,
}
